import * as React from 'react'
import { InteractiveDataProps, InteractiveDataState } from '../common/Chart'
import { YtInteractiveChartHelper } from "../common/YtInteractiveChartHelper"
import { YtModel, ChannelData, ChannelEx } from '../common/YtModel'
import { compactInteger, formatNumber } from 'humanize-plus'
import * as _ from 'lodash'
import { SearchChannels } from '../components/SearchChannels'
import * as dateformat from 'dateformat'
import { Dim, ColEx } from '../common/Dim'
import * as d3 from 'd3'
import { color } from 'd3'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

interface State extends InteractiveDataState { }
interface Props extends InteractiveDataProps<YtModel> { }

let colors = [
  "#002366",
  "#800080",
  "#000080",
  "#97e2ff",
  "#7c4ea2",
  "#00b300",
  "#009a00",
  "#ffb733",
  "#f2d181",
  "#50cadc",
  "#aad6ff",
  "#50cadc",
  "#0241ae",
  "#024bc7",
  "#eeece8",
  "#e3e0d9",
  "#ea8d45",
  "#e7e5e2",
  "#dddad6",
  "#f0ede8",
  "#efece6",
  "#efece7",
  "#1a2a2c",
  "#194343",
  "#cc672a",
  "#ecece5",
  "#e4e4db",
  "#d2d2cf",
  "#eae9e3",
  "#e9e8e3",
  "#eae8e2",
  "#e01e5a",
  "#e61e50",
  "#e53974",
  "#e488a2",
  "#b351f7",
  "#811ec8",
  "#a50948",
  "#7e22df",
  "#8000ff",
  "#fa3b00",
  "#ce890a",
 ]

// let col = { 0: '#8a8acb' , 1: '#e0393e', 3:'#e55e5e' ,4 : '#c68143' , 5 : '#56b881', 6: '#6ec9e0' },
// { value: '7', color: '#3887be' },
// { value: '8', color: '#96cbb3' },
// { value: '9', color: '#b7b7b7' },
// { value: '10', color: '#41afa5' },
// { value: '11', color: '#ffc168' },
// { value: '12', color: '#aa557f' },
// { value: '13', color: '#ac658f' },
// { value: '14', color: '#76abb3' },
// { value: '15', color: '#aaaa98' },
// { value: '16', color: YtModel.colors[0] },
// { value: '17', color: YtModel.colors[1] },
// { value: '18', color: YtModel.colors[2] },
// { value: '19', color: YtModel.colors[3] },
// { value: '20', color: YtModel.colors[4] },
// { value: '21', color: YtModel.colors[5] },
// { value: '22', color: YtModel.colors[6] },
// { value: '23', color: YtModel.colors[7] },
// { value: '24', color: YtModel.colors[8] },
// { value: '25', color: YtModel.colors[9] },
// { value: '26', color: YtModel.colors[10] },
// { value: '27', color: YtModel.colors[11] },
// { value: '28', color: YtModel.colors[12] },
// { value: '29', color: YtModel.colors[13] },
// { value: '30', color: YtModel.colors[14] },
// { value: '31', color: YtModel.colors[15] },
// { value: '32', color: YtModel.colors[16] },
// { value: '33', color: YtModel.colors[17] },
// { value: '34', color: YtModel.colors[18] },
// { value: '35', color: YtModel.colors[19] },
// { value: '36', color: YtModel.colors[20] },
// { value: '37', color: YtModel.colors[21] },
// { value: '38', color: YtModel.colors[22] }

export class ChannelTitle extends React.Component<Props, State> {
  chart: YtInteractiveChartHelper = new YtInteractiveChartHelper(this, 'search')
  state: Readonly<State> = {
    selections: this.props.model.selectionState
  }

  get dim(): Dim<ChannelData> {
    return this.props.model.channels
  }

  channel() {
    const channelId = this.chart.selections
      .highlightedOrSelectedValue(this.dim.col("channelId"))
    return channelId ? this.props.model.channels.rows.find(c => c.channelId == channelId) : null
  }

  tagAlias: Record<string, string> = {
    ManoelAltLite: 'Ribeiro - Alt-light',
    ManoelAltRight: 'Ribeiro - Alt-right',
    ManoelIDW: 'Ribeiro - IDW',
    ManoelControl: 'Ribeiro - Control',
    AntiSJW: 'Anti-SJW',
    SocialJusticeL: 'Social Justice',
    WhiteIdentitarian: 'White Identitarian',
    PartisanLeft: 'Partisan Left',
    PartisanRight: 'Partisan Right',
    AntiTheist: 'Anti-theist',
    ReligiousConservative: 'Religious Conservative',
    MissingLinkMedia: 'Missing Link Media',
    StateFunded: 'State Funded',
    AntiWhiteness: 'Anti-whiteness',
    LateNightTalkShow: '_',
    Revolutionary: '_'
  }

  render() {
    let channel = this.channel()
    let dateFormat = (d: Date) => d ? dateformat(d, 'd mmm yyyy') : d

    const renderChannel = (c: ChannelData) => {
      // let tags = c.tags.length == 0 ? ['None'] : c.tags.map(t => this.tagAlias[t] ?? t).filter(t => t != '_')
      // let lrCol = this.props.model.channels.col('lr')
      // let labelFunc = ColEx.labelFunc(lrCol)
      // let colorFunc = ColEx.colorFunc(lrCol)
      // let lrColor = (v: string) => d3.color(colorFunc(v)).darker(2).hex()
      let advantage = ChannelEx.impressionAdvantagePercent(c)
      function FormRow() {
        return (
          <React.Fragment>
            <Grid item xs={4}>
              <Paper >item</Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper >item</Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper >item</Paper>
            </Grid>
          </React.Fragment>
        );
      };
      let repls = c.replied_to.replace('[', '').replace(']', '');
      let svo = c.svo.length > 0 ? c.svo: c.ngrams;
      // let new_str = repls.split(' ').map((TOKEN) => { if (!TOKEN.includes(')')) return '<span>' + TOKEN + '<span>'; else return TOKEN; });
      // repls = new_str.join(' ')
      return (<>
    <div style={{float: "left", backgroundColor: '#555555'}} id="advanced">{c.channelId.replace('n', '')}</div>
        <div className="title-details" style={{ width: '100%', float: 'right'}}>
      {/* <div>Text: <b>{c.title}</b></div> */}
      {/* <div className="attr-title"><h3>Sub-community Information</h3></div> */}
      {/* style={{backgroundColor: 'gray', padding: 4 + 'px', borderRadius: '4px', width: '130px'}} */}
          {/* <div className="attr-details">
            <b>Sub-community ID</b>: <i>{c.channelId}</i>
          </div> */}
         
          <div className="attr-details" style={{marginTop: '30px'}}>
      {<><b style={{padding: 4 + 'px', backgroundColor: 'red', borderRadius: '4px'}}>Community ID</b> <i style={{textAlign: 'center', display: 'inline-block', width: '20px', padding: 4 + 'px', backgroundColor: 'green', borderRadius: '4px'}}>{c.community}</i>   <b style={{marginLeft: '20px', padding: 4 + 'px', backgroundColor: 'red', borderRadius: '4px'}}>Sub-Community Size</b> <i style={{textAlign: 'center', display: 'inline-block', width: '45px', padding: 4 + 'px', backgroundColor: 'green', borderRadius: '4px'}}>{c.size}</i> </>}
          </div>
          <hr style={{marginTop: '10px', width: '98%'}}></hr>
          <div className="attr-details" style={{marginTop: '10px', marginLeft: '123px'}}>
          <b style={{padding: 4 + 'px', backgroundColor: 'rgb(110, 28, 30)', borderRadius: '4px'}}>Sentiment Score</b> <i  style={{ display: 'inline-block', width: '70px', padding: 4 + 'px', backgroundColor: '#555555', borderRadius: '4px'}}>{parseFloat(c.sentiment).toFixed(4)}</i>
          <b style={{marginLeft: '20px', padding: 4 + 'px', backgroundColor: 'rgb(110, 28, 30)', borderRadius: '4px'}}>Replied To</b> 
    <i  style={{ marginLeft: '4px', width: '20px', padding: 4 + 'px', backgroundColor: '#555555', borderRadius: '4px'}}> { repls.split(' ').map((tok)=>  tok.indexOf(')') == -1? <span style={{color: '#0000CD'}}> <a style={{color: ''}} href={"https://twitter.com/" + tok}> { tok } </a> </span>  : ' ' + tok + ',' ) }   </i>
          </div>
          <div className="attr-details"  style={{marginTop: '10px', marginLeft: '123px'}}>
           <b style={{padding: 4 + 'px', backgroundColor: 'rgb(110, 28, 30)', borderRadius: '4px'}}>{c.svo.length > 0 ? "Subject-Verb-Object Sets" : "N-Grams"}</b> <i style={{ width: '20px', padding: 4 + 'px', backgroundColor: '#555555', borderRadius: '4px'}}>{svo.split(' ').map((tok)=>  <span > { tok }</span> ) }</i>
          </div>
          <div>
          {/* <Grid container spacing={1}>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <FormRow />
        </Grid>
      </Grid> */}
          </div>
          {/* <div><span key={c.lr} className={'tag'} style={{ backgroundColor: lrColor(c.lr) }}>{labelFunc(c.lr)}</span>{tags.map(t => (<span key={t} className={'tag'}>{t}</span>))}</div> */}
        </div>
      </>)
    }

    return (
      <div className={'Title'}>
        <div className={'Card'}>
          {channel == null ? (
            <div style={{marginLeft: '20px'}}>
              <h1><span style={{color: '#7C9ED1'}} >Interactive </span> <span style={{color: '#02B9FF'}}>visualization of</span> <span style={{color: '#7C9ED1'}} > direct replies</span> <span style={{color: '#02B9FF'}}> to prominent </span> <span style={{color: '#7C9ED1'}}>US politicians</span> <span style={{color: '#02B9FF'}}>on Twitter</span></h1>
              <p style={{marginLeft: '15px'}}><i>Click on a node or community to see details. Zoom-In and Zoom-out with the scroll wheel. Drag anywhere to navigate the graph.</i></p>
            </div>
          ) : (
              renderChannel(channel)
            )}
        </div>
        {/* <div className={'Search'} style={{}}>
          <SearchChannels model={this.props.model} onSelection={this.props.onSelection} selections={this.state.selections} />
        </div> */}
      </div>
    )
  }
}
